import { FlexColumn, IconButton, PaneHeader } from "designSystem/index";
import React from "react";
import DojoView from "csi/page/DojoView";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import locale from "csi/locale";
import { action } from "mobx";
import IconArrowExpandHorizontal from "designSystem/components/icon/ArrowExpandHorizontal";
import ArrowCollapseHorizontal from "designSystem/components/icon/ArrowCollapseHorizontal";
import IngredientContributorPaneComponent from "./IngredientContributorPaneComponent";

const IngredientContributorPane = observer(() => {
	const { rightPaneStore } = useStore();
	const { closeSelected, expandSelected, collapseSelected, isFullWidth } = rightPaneStore;
	const selected = rightPaneStore.selected;
	const { foodIngredient, ingredientItem, ingredientItemUrl, config } = selected as IngredientContributorPaneComponent;
	const { setResizeWidth, getResizeWidth, resizable, viewWidth } = config;

	const resetComponentWidth = action(() => {
		if (!isFullWidth) {
			expandSelected();
		} else {
			collapseSelected();

			rightPaneStore.selectedWidth = viewWidth * 2;
			setResizeWidth(viewWidth * 2);
		}
	});

	const closeAndResetWidth = action(() => {
		collapseSelected();

		rightPaneStore.selectedWidth = viewWidth * 2;
		setResizeWidth(viewWidth * 2);

		closeSelected();
	});

	const viewIdSuffix: string = "ContributorSidebar";

	// Pane Header with a 
	const title: string = foodIngredient ? 
		locale.resource("IngredientItemContributorSidebarTitle", [foodIngredient?.$Name]):
		locale.type("IngredientItemContributor");

	return (
		<FlexColumn>
			<PaneHeader 
				title={title} 
			>
				<IconButton
					design="default"
					onClick={resetComponentWidth}
					res={isFullWidth ? "CollapsedView": "ExpandedView"}
					size="large"
				>
					{isFullWidth ? <ArrowCollapseHorizontal />: <IconArrowExpandHorizontal />}
				</IconButton>
				<IconButton
					aria-label="close"
					onClick={closeAndResetWidth}
					size="large"
					style={{ marginLeft: 4 }}
				>
					<CloseIcon />
				</IconButton>
			</PaneHeader>
			{ingredientItemUrl && (
				<Box
					flexGrow={1}
					overflow="hidden"
					padding="1rem"
					width="100%"
				>
					<DojoView
						fullHeight
						nodeUrl={ingredientItem.$URL}
						viewId={ingredientItem.$Type + viewIdSuffix}
						viewNodeType={ingredientItem.$Type}
					/>
				</Box>
			)}
		</FlexColumn>
	);
});

export default IngredientContributorPane;